<div class="w2-no-sell-items text-center w2-empty-view col-xs-12">
	<div class="w2-no-sell-items-icon h1 text-danger">
		<i class="fa fa-times-circle"></i>
	</div>
	<p class="w2-no-sell-items-text help-block">
		{{{noSellingItemsMessage}}}
	</p>
</div>